import React, { useEffect, useState } from 'react'
import {
  FormBox2, TextBox, FieldLayoutSizes, RadioListBox, Row, PasswordBox
} from 'common-controls/Core/index'
import { ah, sh, compose, ReduxWrapper, QueryWrapper } from 'common-data/datahelpers'
import { BuildMessageBusEvents } from 'common-tools/index'
import _ from 'lodash'
import { WizardStepContainer, WizardStep } from 'common-controls/Core/WizardStepBox'

export const ProfilePasswordChangesEvents = BuildMessageBusEvents('ProfileAccount.ProfilePasswordChange')

const PasswordChangeSteps = {
  EmailOrPhone: 'emailorphone',
  ConfirmCode: 'confirmcode',
  NewPassword: 'phone'
}

let IsPasswordValid = false

const formName = 'ProfilePasswordChange'
const stopAction = true
const allowAction = false

function ProfilePasswordChangesPlain (props) {
  const {
    GetVerificationChannels,
    formCheckForSubmissionErrors,
    formSetValidation,
    SessionAccount,
    showSuccess,
    close,
    ChangePassword,
    data = {},
    formDataPasswordChange,
    formSubmit,
    ValidateChannel,
    ValidateChannelCode,
    VerifyPassword
  } = props

  const {
    loadingPasswordChange = false,
    loadingValidateChannelCode = false,
    loadingValidateChannel = false,
    loadingVerifyPassword = false
  } = data

  const [loading, setLoading] = useState(false)

  const [completedSteps, setCompletedSteps] = useState([])

  useEffect(() => {
    setLoading(loadingPasswordChange || loadingValidateChannelCode || loadingValidateChannel || loadingVerifyPassword)
  }, [loadingPasswordChange, loadingValidateChannelCode, loadingValidateChannel, loadingVerifyPassword])

  useEffect(() => {
    async function doit () {
      try {
        await GetVerificationChannels({ AccountKey: SessionAccount._key })
      } catch (err) {
        formCheckForSubmissionErrors(err, false)
        formSetValidation(formName, err)
      }
    }
    doit()
  }, [])

  async function beforeStepAction (nextStep, previousStep, direction) {
    let errors = {}

    if (direction === 'previous') {
      return allowAction
    }

    switch (previousStep) {
      case PasswordChangeSteps.EmailOrPhone:
        if (!formDataPasswordChange.ChannelKey) {
          errors.ChannelKey = 'Please select a medium'
          formSetValidation(formName, errors)
          return stopAction
        } else {
          try {
            await ValidateChannel({ AccountKey: SessionAccount._key, ChannelKey: formDataPasswordChange.ChannelKey })
          } catch (err) {
            const ret = formCheckForSubmissionErrors(err, false) || {}
            formSetValidation(formName, ret.data || ret, ret.fields)
            return stopAction
          }
        }
        setCompletedSteps(_.uniq(_.concat(completedSteps, previousStep)))
        return allowAction

      case PasswordChangeSteps.ConfirmCode:
        if (!formDataPasswordChange.ConfirmCode) {
          errors.ConfirmCode = 'Please type a valid code'
          formSetValidation(formName, errors)
          return stopAction
        } else {
          try {
            await ValidateChannelCode({ ChannelKey: formDataPasswordChange.ChannelKey, AccountKey: SessionAccount._key, VerificationCode: formDataPasswordChange.ConfirmCode })
          } catch (err) {
            const ret = formCheckForSubmissionErrors(err, false) || {}
            formSetValidation(formName, ret.data || ret, ret.fields)
            return stopAction
          }
        }
        setCompletedSteps(_.uniq(_.concat(completedSteps, previousStep)))
        return allowAction
    }

    throw new Error(`Unexpected pervious step named ${previousStep}`)
  }

  async function afterStepAction (nextStep, previousStep, direction) {

  }

  async function handleOnDone () {
    let errors = {}
    if (!formDataPasswordChange.CurrentPassword) {
      errors.CurrentPassword = 'Please type in current password'
    } else if (!formDataPasswordChange.NewPassword) {
      errors.NewPassword = 'Please type in new password'
    } else if (!formDataPasswordChange.ConfirmNewPassword) {
      errors.ConfirmNewPassword = 'Please retype new password'
    } else if (formDataPasswordChange.ConfirmNewPassword !== formDataPasswordChange.NewPassword) {
      errors.ConfirmNewPassword = 'Passwords are not the same'
      errors.NewPassword = 'Passwords are not the same'
    } else if (!IsPasswordValid) {
      errors.NewPassword = 'Password does not pass the Validation Rules.'
    } else {
      try {
        await VerifyPassword({ AccountKey: SessionAccount._key, Password: formDataPasswordChange.CurrentPassword })
      } catch (err) {
        const ret = formCheckForSubmissionErrors(err, false) || {}
        formSetValidation(formName, ret.data || ret, ret.fields)
        return stopAction
      }
    }

    if (!_.isEmpty(errors)) {
      formSetValidation(formName, errors)
      return stopAction
    }

    formSubmit(formName)
  }

  function handleLogin () {
    const { Logout, clearSettings, clearUser, sendToURL, clearAccount } = props
    Logout({ AccountKey: SessionAccount?._key }).then(() => {
      clearAccount()
      clearUser()
      clearSettings()
      sendToURL('/Login')
    })
  }

  function onSubmit (values) {
    return ChangePassword({ AccountKey: SessionAccount._key, Password: values.NewPassword })
      .then(({ data, extra }) => {
        showSuccess(`Great!!! You have successfully changed your account password.`)
        close([{ Type: ProfilePasswordChangesEvents.Close }, { Type: ProfilePasswordChangesEvents.Success }])
        if (SessionAccount.IsTemporaryPassword) {
          handleLogin()
        }
      })
      .catch(formCheckForSubmissionErrors)
  }

  function handleOnCancel () {
    close([{ Type: ProfilePasswordChangesEvents.Close }])
  }

  return (
    <FormBox2 form={formName} simpleBody initialValues={{}} onSubmit={onSubmit}>
      <WizardStepContainer afterStepAction={afterStepAction} beforeStepAction={beforeStepAction} onCancel={handleOnCancel}
        doneButtonText='Change Password' loading={loading} onDone={handleOnDone} small>
        <StepEmailOrPhone id={PasswordChangeSteps.EmailOrPhone} data={data} sessionAccount={SessionAccount} />
        <StepConfirmCode id={PasswordChangeSteps.ConfirmCode} sessionAccount={SessionAccount} readonly={_.includes(completedSteps, PasswordChangeSteps.ConfirmEmail)} />
        <StepNewPassword id={PasswordChangeSteps.NewPassword} sessionAccount={SessionAccount} readonly={_.includes(completedSteps, PasswordChangeSteps.NewPassword)} formDataPasswordChange={formDataPasswordChange} />
      </WizardStepContainer>
    </FormBox2>
  )
}

function StepEmailOrPhone (props) {
  const { data, id, sessionAccount } = props

  const [channels, setChannels] = useState([])

  useEffect(() => {
    setChannels(_.map(data.GetVerificationChannelsResults
      , (email) => {
        return { Value: email._key, Text: email.Data }
      }))
  }, [data, sessionAccount])

  return (
    <WizardStep showCancelButton={!sessionAccount.IsTemporaryPassword} id={id} title="Let's change your password">
      <p className="lead">Just be sure this is really you, we are going to send you a confrimation code. Where will you like us to send the confirmation code?</p>
      <Row>
        <RadioListBox data-tid='channel' layout={FieldLayoutSizes.Middle}
          name='ChannelKey' options={channels} />
      </Row>
    </WizardStep>
  )
}

function StepConfirmCode (props) {
  const { readonly, id, sessionAccount } = props

  return (
    <WizardStep showCancelButton={!sessionAccount.IsTemporaryPassword} id={id} title="Check your email/text">
      <p className="lead">Check your email/text for the code we just sent you.  If you did not get the code please click the previous button and try again.</p>
      <Row>
        <TextBox readonly={readonly} data-tid='confirmCode' layout={FieldLayoutSizes.Middle} name="ConfirmCode" placeHolder="Please enter the code sent to you." />
      </Row>
    </WizardStep>
  )
}

function StepNewPassword (props) {
  const { id, readonly, sessionAccount } = props

  function setPasswordValid (valid) {
    IsPasswordValid = valid
  }

  return (
    <WizardStep showCancelButton={!sessionAccount.IsTemporaryPassword} id={id} title='Type your new password' >
      <p className="lead">Fill out the fields below and click change password.</p>
      <Row>
        <TextBox readonly={readonly} data-tid='currentPassword' layout={FieldLayoutSizes.Middle} type="password" name="CurrentPassword" placeHolder="Current Password" />
        <PasswordBox readonly={readonly} data-tid='newPassword' layout={FieldLayoutSizes.Middle} type="password" name="NewPassword" placeHolder="New Password" isValid={setPasswordValid.bind(this)} />
        <TextBox readonly={readonly} data-tid='confirmPassword' layout={FieldLayoutSizes.Middle} type="password" name="ConfirmNewPassword" placeHolder="Confirm New Password" />
      </Row>
    </WizardStep>
  )
}

export const ProfilePasswordChanges = compose(
  ReduxWrapper([
    sh.SessionToken, sh.FormData(formName, 'formDataPasswordChange'),
    sh.SessionAccount
  ], [
    ah.clearAccount,
    ah.clearSettings,
    ah.clearUser,
    ah.sendToURL,
    ah.setAppState,
    ah.formCheckForSubmissionErrors,
    ah.formSetValidation,
    ah.showInfo,
    ah.showSuccess,
    ah.formSubmit,
    ah.setAccount
  ]),
  QueryWrapper({
    key: formName,
    actions: [
      {
        url: '/Services/Profile/Channel/GetVerificationChannels',
        prop: 'GetVerificationChannels',
        map: 'GetVerificationChannelsResults'
      },
      {
        url: '/Services/Security/Shared/ValidateChannel',
        prop: 'ValidateChannel',
        map: 'ValidateChannelResult'
      },
      {
        url: '/Services/Security/Shared/ValidateChannelCode',
        prop: 'ValidateChannelCode',
        map: 'ValidateChannelCodeResult'
      },
      {
        url: '/Services/Profile/ChangePassword',
        prop: 'ChangePassword',
        map: 'ChangePasswordResult'
      },
      {
        url: '/Services/Profile/VerifyPassword',
        prop: 'VerifyPassword',
        map: 'VerifyPasswordResult'
      },
      {
        url: '/Services/Profile/Logout',
        prop: 'Logout',
        map: false
      }
    ]
  })
)(ProfilePasswordChangesPlain)

export default ProfilePasswordChanges
